import {
  GET_ENTRY_STRATEGY_BY_ID,
  GET_ENTRY_STRATEGY_BY_ID_FAILED,
  GET_ENTRY_STRATEGY_BY_ID_SUCCESSFUL,
} from './actionTypes';

export const getEntryStrategyById = ({ id, token }) => {
  return {
    type: GET_ENTRY_STRATEGY_BY_ID,
    payload: { id, token },
  };
};

export const getEntryStrategyByIdSuccessful = (entryStrategy, message) => {
  return {
    type: GET_ENTRY_STRATEGY_BY_ID_SUCCESSFUL,
    payload: { entryStrategy, message },
  };
};

export const getEntryStrategyByIdFailed = (message) => {
  return {
    type: GET_ENTRY_STRATEGY_BY_ID_FAILED,
    payload: { message },
  };
};
